<template>
  <div>
    <div class="box"></div>
    <div class="box2">
        <el-menu :default-active="idx" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="0" @click="$router.push('live')">智慧住建</el-menu-item>
            <el-menu-item index="1" @click="$router.push('site')">智慧工地</el-menu-item>
            <el-menu-item index="2" @click="$router.push('schemeSafety')">智慧安全</el-menu-item>
            <el-menu-item index="3" @click="$router.push('schemeCartoon')">工程动画</el-menu-item>
            <el-menu-item index="4" @click="$router.push('schemeShowRoom')">项目展厅展馆</el-menu-item>
        </el-menu>
    </div>
    <div class="box3">
      <div class="main" v-for="item in dataList" :key="item.id" @click="donClick(item.id)">
        <img :src="item.img" class="lef">
        <div>
          <p class="tit">{{ item.title }}</p>
          <p class="txt">{{ item.text }}</p>
        </div>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "SchemeSafety",
  data() {
    return {
      idx: '2',
      dataList: [
        {
          id: 0,
          img: require('./img/safety/1/4.jpg'),
          title: '基于AI技术的全方位工地智慧安全管理系统',
          text: '基于AI技术的全方位工地安全管理系统，借助大数据、人工智能、AI、VR、云计算等先进技术，抓住教育、监督、评估等关键环节，覆盖每个工地、每个人员的生产作业全流程，帮助企业在事故发生前防范于未然，事故发生中懂得自救，事故发生后损失降为最小...'
        }, {
          id: 1,
          img: require('./img/safety/2/1.jpg'),
          title: '安全教育',
          text: '管理人员可将培训的內容、文字、视频等通过云端在线即时推送至屏幕，随时远程在线监控屏幕的播放状态。通过观看触目惊心、鲜血淋漓的各种安全事故案例，深入剖析事故发生的原因和教训，全面增强工人的安全意识...'
        }, {
          id: 2,
          img: require('./img/safety/3/1.png'),
          title: '安全考核',
          text: '安全考核模块由多媒体培训考核教室、“智慧安全云”快速培训系统、安全知识抢答系统、实名制培训箱等组成...'
        }, {
          id: 3,
          img: require('./img/safety/4/1.jpg'),
          title: '安全监管',
          text: '安全监管模块由AI安全隐患识别系统、AI安全行为监管系统、安全巡检行为评价系统、广播提醒协防系统等四部分构成，通过给摄像头配置AI算法，智能监管“人的不安全行为，物的不安全状态”，...'
        }, {
          id: 4,
          img: require('./img/safety/5/1.png'),
          title: '安全评估',
          text: '根据现场安全管理情况可自动生成对劳务工人、项目管理人员、项目的安全评估报告。人员安全评估报告根据从业记录保存更新，项目安全评估报告在系统备案...'
        }
      ]
    }
  },
  methods: {
    donClick(id) {
      this.$router.push({
        path: 'safetyDetail', query: {
          index: id
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 2.9rem;
  width: 100%;
  background: url("./img/banner/2.jpg");
  background-size: 100% 100%;
}

.box2 {
  width: 10rem;
  margin: .34rem auto .6rem;
  text-align: center;

  a {
    text-decoration: none;
  }

  .el-menu-item {
    width: 2rem;
    font-size: .2rem;
    height: .72rem;
    line-height: .72rem;
  }

  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 3px solid #E70F20;
    color: #E70F20;
  }

  .el-menu--horizontal > .el-menu-item {
    color: #000;
  }
}

.box3 {
  width: 12rem;
  margin: 0 auto;

  .main {
    height: 2.2rem;
    background: #FBFBFB;
    display: flex;
    position: relative;
    margin-bottom: .3rem;
    cursor: pointer;

    img.lef {
      width: 3.6rem;
      height: 2.2rem;
    }

    div {
      height: 1.6rem;
      margin: .3rem 0 0 .57rem;

      p.tit {
        font-size: .26rem;
      }

      p.txt {
        width: 6.5rem;
        font-size: .18rem;
        color: #595757;
        line-height: .36rem;
        text-align: justify;
        margin-top: .23rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }

    span {
      position: absolute;
      width: .38rem;
      height: .38rem;
      background: url("../../assets/images/more.png");
      background-size: 100% 100%;
      right: .32rem;
      bottom: .35rem;
      cursor: pointer;
    }
  }
}
</style>
